import { Box, Typography } from "@mui/material";
import FoodTypeDto from "../../../models/FoodTypeDto";

interface FoodTypeProps {
    foodType: FoodTypeDto;
}

export default function FoodType({ foodType }: FoodTypeProps) {
    return (
        <Box key={foodType.id} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Box sx={{ flexGrow: '1' }}>
                <img style={{ maxHeight: '5vh', minHeight: '5vh', width: 'auto' }}
                    src={foodType.imageUrl}
                    alt={foodType.value}
                />
            </Box>
            <Typography className='center white'>{foodType.value}</Typography>
        </Box>
    );
}